import script from "./GuideLines.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideLines.vue?vue&type=script&setup=true&lang=js"

import "./GuideLines.vue?vue&type=style&index=0&id=408442d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408442d9"]])

export default __exports__